module.exports = __webpack_public_path__ + "static/img/product-01.ad590be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-01.jpg
// module id = 9tqd
// module chunks = 7